<template>
  <div
    class="dropdown"
  >
    <div class="dropdown__name" v-if="$slots.default">
      <slot />
    </div>
    <div class="dropdown__input">
      <div
        class="dropdown__box"
        v-if="selectedOption"
        @click="toggleMenu()"
      >
        <slot
          name="renderValue"
          v-bind:opt="selectedOption"
          v-bind:title="true"
        >
          <div class="dropdown__menu-item_default-value">
            {{ displayValue(selectedOption.key, selectedOption.value) }}
          </div>
        </slot>
        <div class="dropdown__icon">
          <div class="dropdown__icon_toggle" />
        </div>
      </div>

      <div
        class="dropdown__box"
        v-else
        @click="toggleMenu()"
      >
        <span class="dropdown__placeholder">
          {{placeholder}}
        </span>
        <div class="dropdown__icon">
          <div class="dropdown__icon_toggle" />
        </div>
      </div>

      <div
        class="dropdown__menu-overlay"
        v-if="showMenu"
        @click="toggleMenu(false)"
      />

      <ul class="dropdown__menu" v-if="showMenu">
        <li
          @click="updateOption(option)"
          class="dropdown__menu-item"
          v-for="option in optionItems"
        >
          <slot
            name="renderValue"
            v-bind:opt="option"
          >
            <div class="dropdown__menu-item_default">
              {{ displayValue(option.key, option.value) }}
            </div>
          </slot>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Dropdown",
    data() {
      return {
        showMenu: false,
      }
    },
    props: {
      options: {
        type: [Array, Object]
      },
      placeholder: [String],
      modelValue: [Number, String, Object],
      itemFormat: Function,
    },
    computed: {
      optionItems() {
        const optionItems = [];
        if (this.options) {
          if (Array.isArray(this.options)) {
            if (typeof(this.options[0]) == "string" || typeof(this.options[0]) == "number") {
              this.options.forEach(value => {
                optionItems.push({
                  key: value,
                  value,
                });
              });
            } else {
              //optionItems = this.options
              this.options.forEach(value => {
                optionItems.push({
                  key: value.id || this.options.length,
                  value,
                });
              });
            }
          } else {
            Object.keys(this.options).forEach(key => {
              optionItems.push({
                key: key,
                value: this.options[key]
              })
            });
          }
        }
        return optionItems;
      },
      selectedOption() {
        let item = undefined;
        const checkFn = typeof(this.modelValue) == 'object'
         ? i => i.value == this.modelValue
         : i => i.key == this.modelValue;
        this.optionItems.forEach(i => {
          if (checkFn(i)) {
            item = i;
          }
        });
        return item;
      },
      propModel: {
        get() { return this.modelValue },
        set(value) {
          //this.$emit('update:modelValue', value)
        },
      },
    },
    methods: {
      updateOption(option) {
        const check = typeof(this.modelValue) == 'object'
          ? option.value != this.modelValue
          : option.key !== this.modelValue;
        if (check) {
          this.$emit('update:modelValue', option.key, option.value);
          this.$emit('input', option.key, option.value);
        }
        this.toggleMenu(false);
      },
      toggleMenu(displayed) {
        if (this.disabled) {
          return
        }
        if (displayed === undefined) {
          this.showMenu = !this.showMenu
        } else {
          this.showMenu = displayed
        }
      },
      displayValue(key, value) {
        return this.itemFormat ? this.itemFormat(key, value) : value
      }
    }
  }
</script>
